module.exports = __webpack_public_path__ + "img/arrow-down.61ddcec9.svg";